module.exports = __webpack_public_path__ + "static/left_offer-0eaf9ac551ffac19199374b7dd42d3bd.png";